import { render, staticRenderFns } from "./ChangePlanUpgrades.vue?vue&type=template&id=2021b090&scoped=true&"
import script from "./ChangePlanUpgrades.vue?vue&type=script&lang=js&"
export * from "./ChangePlanUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlanUpgrades.vue?vue&type=style&index=0&id=2021b090&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021b090",
  null
  
)

export default component.exports